module.exports = __webpack_public_path__ + "img/sc1.5b380029.png";